import React from 'react';
import Icon from '../Icon';
import clsx from 'clsx';

interface StockStatusProps {
  inStock: boolean;
  description: string;
  quantity: number;
  showStock?: boolean;
}

const StockStatus: React.FC<
  StockStatusProps & React.HTMLAttributes<HTMLDivElement>
> = ({
  inStock,
  description,
  quantity,
  showStock,
  className,
  ...props
}) => {
  if (!showStock) {
    return null;
  }
  
  return (
    <div {...props} className={clsx(className, 'flex items-center')}>
      <Icon
        name={inStock ? 'check' : 'cross'}
        className={clsx(
          inStock ? 'bg-success-500' : 'bg-error-500',
          'mr-2 h-4 w-4 rounded-full p-0.5 text-white'
        )}
      />
      <span className="stock-status-description text-sm">
        {description}
      </span>
    </div>
  );
};
export default StockStatus;
